import { useGraphQLQuery } from '@betterment/js-runtime';

import { UserDocument } from './graphql/query.user.generated';

import { urlBuilder } from '../Shared/urlBuilder';

const useCheckingGuard = () => {
  let returnTo = null;
  let queryParams = {};

  const { data } = useGraphQLQuery(UserDocument, { throwOnError: true });

  const isLoading = !data;
  const user = data?.user;

  if (user?.isCheckingDocumentVerificationRequired) {
    returnTo = urlBuilder.getAppDocumentVerifications.absolute();
    queryParams = { product_category: 'checking' };
  }

  return { isLoading, returnTo, queryParams };
};

export default useCheckingGuard;
